<template>
  <div class="container">
    <div class="header d-flex flex-wrap justify-content-between">
      <Search
        v-model="filters.name"
        :focus="true"
        :inside-card="true"
        @search="onSearch"
        @clearSearch="onSearch"
        class="mb20"
      />

      <info-tip
        :tip="shortcutKeyCodeLabel"
        :show-icon="false"
        class="pull-right"
      >
        <button  class="btn btn-carma btn-square pull-right" @click="addRow">
          <i class="fas fa-plus"></i> Add Coder
        </button>
      </info-tip>
    </div>

    <div class="card clearfix">
      <div>
        <datatable
          :loading="showLoader && codersBusy"
          ref="table"
          v-bind:data="datatable"
        />
<!--
        <side-panel v-if="showAddCoder" :onClose="closePanel">
          <template>
            <load-content :loading="isBusy">
              <div id="side-panel-content">
                <h3>Add coder</h3>
                <p>Choose the coder to add</p>
                <input-select
                  name="userCoder"
                  ref="userCoder"
                  :searchable="true"
                  :options="userCoder.filter((c) => !this.coders.some((c2) => c2.id === c.id)).map(t => ({ value: t.id, label: (t.first_name + ' ' + t.last_name) }))"
                  :onChange="onChangeUserCoder"
                />
              <span class="btn btn-carma btn-sm" @click="saveAdd" style="width: 23%">
              <i class="fas fa-check" ></i> Add as coder
            </span>
              </div>
            </load-content>
          </template>
        </side-panel> -->
        <side-panel v-if="showRemoveCoder" :onClose="closePanel">
          <template>
            <load-content :loading="codersBusy">
              <confirm-delete
                  :label="removeCoderObj.name"
                  :title="'messages.confirm_delete.title_coder'"
                  :message="'messages.confirm_delete.message_remove'"
                  :deleteButtonLabel="'remove'"
                  :onDelete="() => removeCoder(removeCoderObj)"
              />
            </load-content>
          </template>
        </side-panel>
      </div>
   </div>

    <side-panel v-if="showAddCoder" :onClose="closePanel">
      <form-renderer
          :loading="codersBusy"
          :id="'add-coder-form'"
          :title="'project.form.add_coder.title'"
          :submitButtonLabel="'form.button.add'"
          :fields="['coder_id']"
          :fieldsAdditions="{coder_id: {options: coderOptions, searchable: true}}"
          @onSave="saveAdd"
      />
    </side-panel>
  </div>
</template>

<script>
import Datatable from '../datatable';
import SidePanel from '../side-panel';
import Moment from 'moment';
import LoadContent from '../load-content';
import { FORMATS, FIELD_TYPE } from "../../config/const";
import { propsForMixin } from "../../helpers/application";
import runShortcut from "../../mixins/shortcuts"
import CodingHeadline from '../coding-headline';
import CoderPicker from '../coder-picker';
import ConfirmDelete from "../confirm-delete";
import FormRenderer from '../form-renderer';
import { mapState, mapActions } from 'vuex';
import InfoTip from "../info-tip";
import Search from "../../components/Search.vue";

export default {
  name: 'CodersList',
  components: {
    datatable: Datatable,
    LoadContent,
    SidePanel,
    ConfirmDelete,
    FormRenderer,
    InfoTip,
    Search,
  },
  created() {
    window.addEventListener('scroll', this.scroll);
    const { projectId, pagination } = this;
    this.getCoders({ projectId , pagination })
        .then(() => this.isReady = true);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll);
  },
  computed: {
    ...mapState({
    coders: state => state.articles.coders.data,
    codersBusy : state => state.articles.coders.isBusy,
    codersPagination: state => state.articles.coders.pagination,
    loading: state => state.articles.articles.isBusy,
    userCoder: state => state.user.userCoder.data,
    }),
    coderOptions() {
      return this.userCoder.filter((c) => !this.coders.some((c2) => c2.id === c.id)).map(t => ({ value: t.id, label: (t.first_name + ' ' + t.last_name) }))
    },
    datatable(){
      const { coders } = this;
      const self = this;
      const body = coders || [];
      return {
      custom_components: {
          'coder-picker': CoderPicker,
          'coding-headline': CodingHeadline
        },
      columns: [
        {
          key: 'name',
          label: 'name',
          orderable: true,
          style: { 'min-width': '300px' },
          input: {
            name: 'name',
            component: {
              name: 'coding-headline',
              getProps: function(row) {
                const coder = { ...row };
                return {
                  ...row,
                  coder,
                  onClick: function(id) {
                    const projectUrl = `/analysis/coders/${id}`;
                    self.$router.push(projectUrl);
                  },
                }
              }
            },
          }
        },
        {
          key: 'last_coded',
          label: "Last Coded",
          orderable: true,
          input: {
            name: 'last_coded',
            type: FIELD_TYPE.CALENDAR,
            placeholder: "N/A",
            disabled: true,
          },
        },
        {
          key: 'available',
          label: "Availability",
          orderable: true,
          input: {
            name: 'available',
            type: FIELD_TYPE.SELECT,
            options: [{ value: true, label: 'Available' }, { value: false, label: 'Not Available' }],
            searchable: false,
            multiple: false,
            allowEmpty: false,
            placeholder: "",
            disabled: true,
          },
        },
        {
          key: 'articles',
          label: 'Associated Articles ',
          orderable: true,
          render: ({articles, id} = {}) => {
            return (parseInt(articles) > 0 ? <router-link style="color:#ec9148;" to={`/analysis/projects/${this.$route.params.project_uid}/coders/${id}/articles?page=1`}>{articles}</router-link> : <span>0</span>)
          }
        }
    ],
      body: this.coders,
      order: {
        column: self.pagination.order,
        direction: self.pagination.sort,
        onChange: function(column, direction) {
          self.onSortTable({ order: column, sort: direction });
        }
      },
      colReorder: {
        enabled: false,
        disabledColumnsLeft: 1
      },
      removeRow: {
        enabled: true,
        onClick: (row) => {
          self.showRemoveCoder = true;
          return {
            ...self.removeCoderObj = row
          }
        }
      }
    }
    },
    projectId() {
      return this.$route.params.project_uid;
    }
  },
  methods: {
    ...mapActions({
      getCoders: 'articles/getCoders',
      getUserCoder: 'user/getUserCoder',
      addUserCoder: 'articles/addUserCoder',
      removeCodersFromProject: 'articles/removeCodersFromProject',
    }),
    onSearch() {
      this.showLoader = true;
      this.pagination.page = 1;
      this.getCoders({
        projectId: this.projectUid,
        pagination: this.pagination,
        filters: this.filters,
      })
    },  
    closePanel: function() {
      this.showAddCoder = false;
      this.showCoderInfo = false;
      this.showRemoveCoder = false;
    },
    onSortTable: async function({order, sort}) {
        this.showLoader = true;
        let pagination = {};
        pagination.order = order;
        pagination.sort = sort;
        pagination.page = 1;
        pagination.perPage = this.pagination.perPage;
        this.pagination = pagination;
        this.getCoders({projectId: this.projectId, pagination: this.pagination, filters: this.filters})
      },
    addRow() {
      this.showAddCoder = true;
    },
    onChangeUserCoder: function(value) {
      const uc = this.userCoder;
      const ucIndex = this.userCoder.findIndex(c => c.id == value);
      const user = uc[ucIndex];
      const name = uc[ucIndex].first_name + ' ' + uc[ucIndex].last_name
      this.coderAdd = { ...user, name };
    },
    saveAdd: function(coder) {
      const projectId = this.$route.params.project_uid;
      this.addUserCoder({ projectId, row: {id: coder.coder_id} }).then(r => {
        this.showAddCoder = false;
        this.getUserCoder({ projectId });
      })
      
    },
    removeCoder: function(value) {
        const projectId = this.$route.params.project_uid;
        this.removeCodersFromProject({ projectId, row: value}).then(r => {
          this.getCoders({projectId})
          this.showRemoveCoder = false;
        });
        
    },
    scroll() {
      if (this.codersPagination.currentPage < this.codersPagination.totalPages) {
        const wHeight = window.innerHeight;
        const { top, height } = this.$refs.table.$el.getBoundingClientRect();
        const margin = 100;

        if (top * -1 + wHeight >= height - margin && this.codersBusy == false) {
          this.pagination.page += 1;
          const { projectId, pagination, filters } = this;
          this.getCoders({ projectId, pagination, filters }).then(() => {
            this.showLoader = false;
          });
        }
      }
    }
  },
  data: function() {
    const projectUid = this.$route.params.project_uid;
    return {
      filters: {
        name: '',
      },
      projectUid,
      showAddCoder: false,
      confirmAdd: false,
      showLoader: true,
      pagination: {
        page: 1,
        perPage: 20,
        order: "id",
        sort: "asc"
      },
      coderAdd: {},
      showRemoveCoder: false,
      removeCoderObj: {}
    };
  },
  mixins: [propsForMixin, runShortcut('addTag')],
  mounted ()  {
    this.getUserCoder({ projectId: this.projectUid });
  },
};
</script>